import { FC, useEffect } from "react";

const MetaNoIndex: FC = () => {
    useEffect(() => {
        const meta = document.createElement("meta");
        meta.name = "robots";
        meta.content = "noindex";

        document.head.appendChild(meta);

        return () => {
            if (document.head.contains(meta)) {
                document.head.removeChild(meta);
            }
        };
    }, []);

    return null;
};

export default MetaNoIndex;
